import React, { useContext } from 'react';
import { ApiContext } from '../../../UseContext/ApiCall';
import { Modal } from 'react-bootstrap';
import { AwsFileUrl, BASE_URL_STATIC } from '../../../../../config';


const HomeVideoTagPopup = () => {

  const {
    showHomeVideoTagPopup, setShowHomeVideoTagPopup,
    homeVideoAddedTags,
  } = useContext(ApiContext);


  // console.log('homeVideoAddedTags : ', homeVideoAddedTags);


  // handle close home video tag popup
  const handleCloseHomeVideoTagPopup = () => {
    setShowHomeVideoTagPopup(false);
  };
  

  return (
    <>
      <Modal show={showHomeVideoTagPopup} onHide={handleCloseHomeVideoTagPopup} centered backdrop="static" keyboard={false} className="main-modal" >
        <Modal.Header className='pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3'>Tag</h5>
        </Modal.Header>

        <Modal.Body>
          {/* Search Bar */}
          <div className="d-flex flex-grow-1 rounded-pill bg-body-secondary p-1 p-sm-2 my-3">
            <img className="mx-2" src={`${BASE_URL_STATIC}/icon/search.svg`} alt="search" />

            <input type="search" className="rounded-pill bg-body-secondary w-100 border-0" id="search" name="search" autoComplete='off' placeholder={`Search here...`} 
              // value={cnpTagSearchText} onChange={handleSearch}
            />
          </div>

          {/* Added */}
          <>
            {
              (homeVideoAddedTags && homeVideoAddedTags.length > 0)
              && 
              <div>
                <h5 className='mb-3'>Added</h5>

                <div className={`${(homeVideoAddedTags.length > 3) && 'overflow-y-scroll'} pe-2`} style={{ maxHeight: '25vh' }}>
                  {
                    homeVideoAddedTags.map((value, index) => (
                      <div className='d-flex align-items-center gap-3 mb-3' key={index}>
                        <img src={AwsFileUrl+value.profile} className='rounded-circle' style={{ height: '40px', width: '40px' }} alt="profile" />                  

                        <div className='me-auto'>
                          <h5 className='mb-0'>{value.name}</h5>
                          <span className='text-secondary'>{value.userName}</span>
                        </div>

                        <button type="button" className='btn btn-warning btn-sm' >Remove</button>
                      </div>
                    ))
                  }
                </div>

                <hr className='hr' />
              </div>
                
            }
          </>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default HomeVideoTagPopup;